
document.getElementById("dptmntBckBtn").addEventListener("click", function () {
  history.back();
});

let yesAptmntWrapper = document.getElementById('yesAptmntWrapper');
let noAptmntWrapper = document.getElementById('noAptmntWrapper');
let cmnTab = document.querySelectorAll('.cmn-tab');
let aptActive = document.querySelector('.apt.active');
cmnTab.forEach(function (el) {
  el.addEventListener('click', function () {
    this.classList.add('disbtn');
    aptActive.classList.add('disbtn');
    document.querySelectorAll('.dfinal').forEach(s => s.remove());
    let id = this.id;
    if (id.includes("docDptmntTab")) {
      noAptmntWrapper.style.display = 'none';
      yesAptmntWrapper.style.display = 'none';
      document.getElementById("consltDptmntSection").style.display = "block";
      document.getElementById("consltAptmntSection").style.display = "none";
      cmnTab.forEach(s => s.classList.remove('disbtn'));
      aptActive.classList.remove('disbtn');
    } else {

      let appointmentsParm = {
        phone: window.appointmentsParm.phone
      };

      fetch('https://phplaravel-1064273-5765427.cloudwaysapps.com/api/rforrabbit/appointments', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(appointmentsParm)
      })
      .then(res => res.json())
      .then(resdata => {
        if(resdata.success) {
          let appointments = resdata?.data?.data || [];
          if (appointments.length === 0) {
            yesAptmntWrapper.style.display = 'none';
            noAptmntWrapper.style.display = 'block';
          } else {
            appointments.forEach(item => {
              const dateObj = new Date(item.scheduled_at);

              // Format time: e.g., 4:00PM
              const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
              const timeStr = dateObj.toLocaleTimeString('en-US', timeOptions).replace(/ /g, '');

              // Format date: e.g., 15 May, 2025
              const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
              const dateStr = dateObj.toLocaleDateString('en-GB', dateOptions).replace(/ /g, ' ').replace(' ', ' ');

              // Build HTML block
              const html = `
                <div class="rddoc-listc dfinal">
                  <div class="rddoc-litm active">
                    <div class="rddoc-llft">
                      <div class="rddoc-desk">${item.consultation_type.charAt(0).toUpperCase() + item.consultation_type.slice(1)} Consultation</div>
                      <div class="rddoc-meet">
                        <div class="rddoc-meettm">
                          <div class="rddoc-mticn">
                            <img srcset="https://cdn.shopify.com/s/files/1/0428/4973/files/mtime.svg?v=1752475484" width="" height="" alt="Time icon" loading="lazy">
                          </div>
                          <div class="rddoc-mttime">${timeStr}</div>
                        </div>
                        <div class="rddoc-meettm">
                          <div class="rddoc-mticn">
                            <img srcset="https://cdn.shopify.com/s/files/1/0428/4973/files/mdate.svg?v=1752475484" width="" height="" alt="Calender icon" loading="lazy">
                          </div>
                          <div class="rddoc-mtdate">${dateStr}</div>
                        </div>
                      </div>
                    </div>
                    <div class="rddoc-lrft">
                      <div class="rddoc-img">
                        <img srcset="https://cdn.shopify.com/s/files/1/0428/4973/files/rabbit_doctore_img.png?v=1756471178" width="" height="" alt="Rabbit Doctor" loading="lazy">
                      </div>
                    </div>
                  </div>
                </div>
              `;

              yesAptmntWrapper.insertAdjacentHTML('beforeend', html);
            });

            noAptmntWrapper.style.display = 'none';
            yesAptmntWrapper.style.display = 'block';
          }
          document.getElementById("consltAptmntSection").style.display = "block";
          document.getElementById("consltDptmntSection").style.display = "none";
        }
      })
      .catch(err => {
        console.error("Error in appointment creation:", err);
        let errmsg = `<span>Something went wrong. Try after sometime.</span>`;
        showStatus(errmsg, 'errmsg', 'appendNodeClass');
      });

      // cmnTab.forEach(s => s.classList.remove('disbtn'));
      // aptActive.classList.remove('disbtn');
    }
  });
});

let bookConsltBtn = document.querySelector('#bookConsltBtn');
bookConsltBtn.addEventListener('click', function () {
  document.getElementById("consltDptmntSection").style.display = "block";
  document.getElementById("consltAptmntSection").style.display = "none";
});


let bookConfrmBckBtn = document.querySelector('#bookConfrmBckBtn');
bookConfrmBckBtn.addEventListener('click', function () {
  let consltMode = document.querySelector('#consltMode');
  let bookingMode = consltMode.dataset.bookMode;
  if(bookingMode == "Instant") {
    document.getElementById("bookConfrmSection").style.display = "none";
    document.getElementById("consltDptmntSection").style.display = "block";
    document.getElementById("bookConfrmSection").classList.remove("custom-run");
  }else if(bookingMode == 'Scheduled') {
    document.getElementById("bookConfrmSection").style.display = "none";
    document.getElementById("schdlBookingSection").style.display = "block";
    document.getElementById("bookConfrmSection").classList.remove("custom-run");
    let currentDate = new Date();
    fetchAndRenderSlots(formatOnlyDate(currentDate)); // load time slots for today
  }else {
    console.log('Something went wrong');
  }
});

let instBookBtn = document.querySelector('#instBookBtn');
if(instBookBtn) {
  instBookBtn.addEventListener('click', function () {
    let now = new Date();
    let utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    let istTime = new Date(utc + (5.5 * 60 * 60 * 1000));
    let hour = istTime.getHours();    // 0 - 23
    let minute = istTime.getMinutes(); // 0 - 59
    // Allowed time range: 9:00 AM to 8:45 PM IST
    let isWithinRange = (hour > 9 && hour < 20) ||               // 10:00 AM – 7:59 PM
                            (hour === 9 && minute >= 0) ||           // 9:00 AM – 9:59 AM
                            (hour === 20 && minute <= 45);            // 8:00 PM – 8:45 PM
    if (!isWithinRange) {
      alert("Instant booking is not available between 9:00 PM to 9:00 AM.");
      return;
    }
    
    document.getElementById("bookConfrmSection").style.display = "block";
    document.getElementById("consltDptmntSection").style.display = "none";
    confirmBookingPage('Instant', '');
  });
}

function confirmBookingPage(consltModeValue, schdlDateTime) {
  let now = new Date();
  let consltMode = document.querySelector('#consltMode');
  consltMode.dataset.bookMode = consltModeValue;
  consltMode.innerHTML = consltModeValue;
  document.getElementById("bookConfrmSection").classList.add("custom-run");


  if(consltModeValue == 'Instant') {

    let minutes = now.getMinutes();
    // --- Dynamic rule for always jumps +30 minutes from the next 15-minute boundary ---
    let minutesToNextSlot = 15 - (minutes % 15);
    let totalMinutesToAdd = minutesToNextSlot + 15;
    now.setMinutes(minutes + totalMinutesToAdd);
    now.setSeconds(0);
    now.setMilliseconds(0);

    let timeString = now.toLocaleTimeString('en-IN', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    let day = now.getDate();
    let month = now.toLocaleString('en-IN', { month: 'long' });
    let year = now.getFullYear();

    let daySuffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    let dateString = `${timeString}, ${day}${daySuffix(day)} ${month}, ${year}`;

    let bookingDateTimeEl = document.querySelector('#bookingDateTime');
    bookingDateTimeEl.dataset.bookTime = dateString;
    bookingDateTimeEl.innerHTML = dateString;
  }else if(consltModeValue == 'Scheduled') {
    let minutes = now.getMinutes();
    // --- Custom rule ---
    let slotMinutes;
    if (minutes <= 8) {
      // same hour :15
      // console.log('same hour :15')
      slotMinutes = 15;
    } else if (minutes <= 22) {
      // same hour :30
      // console.log('same hour :30')
      slotMinutes = 30;
    } else if (minutes <= 37) {
      // same hour :45
      // console.log('same hour :45')
      slotMinutes = 45;
    }else if (minutes <= 51) {
      // next hour :00
      // console.log('next hour :00')
      now.setHours(now.getHours() + 1); // push to next hour
    }else {
      // 52–59 ⇒ next hour :15
      // console.log('52 to 59 ⇒ next hour :15')
      slotMinutes = 15;
      now.setHours(now.getHours() + 1); // push to next hour
    }
    now.setMinutes(slotMinutes, 0, 0);

    let timeString = now.toLocaleTimeString('en-IN', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    let day = now.getDate();
    let month = now.toLocaleString('en-IN', { month: 'long' });
    let year = now.getFullYear();

    let daySuffix = (d) => {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
    let dateString = `${timeString}, ${day}${daySuffix(day)} ${month}, ${year}`;

    let bookingDateTimeEl = document.querySelector('#bookingDateTime');
    if(schdlDateTime == '') {
      schdlDateTime = dateString;
    }
    bookingDateTimeEl.dataset.bookTime = schdlDateTime;
    bookingDateTimeEl.innerHTML = schdlDateTime;
    document.getElementById("editSchdl").style.display = "block";
  }else {
    console.log('Something went wrong');
  }
}


const input = document.getElementById("baby_dob");
const todayDate = new Date();
// Helper: Format date to YYYY-MM-DD
function formatDate(date) {
  return date.toISOString().split("T")[0];
}
input.max = formatDate(todayDate);
const tenYearsAgo = new Date();
tenYearsAgo.setFullYear(todayDate.getFullYear() - 10);
input.min = formatDate(tenYearsAgo);

let confirmBookingBtn = document.getElementById('confirmBookingBtn')
confirmBookingBtn.addEventListener('click', function () {
  // Get all form values
  const babyName = document.getElementById('baby_name').value.trim();
  const babyAge = document.getElementById('baby_dob').value.trim();
  const parentName = document.getElementById('parent_name').value.trim();
  const concern = document.getElementById('concern').value.trim();
  const mobile = document.getElementById('mobile').value.trim();
  const email = document.getElementById('email').value.trim();
  // Define regex patterns
  const namePattern = /^[A-Za-z\s]+$/;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const numberPattern = /^[0-9]{10}$/;

  // Validation
  if (!namePattern.test(babyName)) {
    alert("Please enter a valid baby's name");
    return;
  }
  if (babyAge == '') {
    alert("Please enter a baby's DOB");
    return;
  }
  if (!namePattern.test(parentName)) {
    alert("Please enter a valid parent name");
    return;
  }
  if (concern == '') {
    alert("Please explain baby concern");
    return;
  }
  if (!emailPattern.test(email)) {
    alert("Please enter a valid Email address");
    return;
  }
  if (mobile === '') {
    alert("Please enter mobile number");
    return;
  }

  if (!numberPattern.test(mobile)) {
    alert("Please enter a valid 10 digit mobile number");
    return;
  }

  let isActive = document.getElementById("bookConfrmSection")?.classList.contains("custom-run");
  if(isActive) {
    let consltMode = document.querySelector('#consltMode');
    let bookingMode = consltMode.dataset.bookMode;
    let bookDateTime = document.querySelector('#bookingDateTime');
    let bookingDateTime = bookDateTime.dataset.bookTime;
    console.log(bookDateTime);
    console.log(bookingDateTime);
    const babyDetails = {
      babyName: babyName,
      babyAge: babyAge,
      parentName: parentName,
      concern: concern,
      mobile: '+91'+mobile,
      email: email
    };
    finalBookingConfirmation(bookingMode, bookingDateTime, babyDetails);
  }
});


let lacConsltBckBtn = document.querySelector('#lacConsltBckBtn');
lacConsltBckBtn.addEventListener('click', function () {
  document.getElementById("consltDptmntSection").style.display = "block";
  document.getElementById("schdlBookingSection").style.display = "none";
});

let schdlBookBtn = document.querySelector('#schdlBookBtn');
schdlBookBtn.addEventListener('click', function () {
  document.getElementById("schdlBookingSection").style.display = "block";
  document.getElementById("consltDptmntSection").style.display = "none";
  
  let currentDate = new Date();
  fetchAndRenderSlots(formatOnlyDate(currentDate)); // load time slots for today
});

function formatOnlyDate(date) {
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, "0");
  let day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const confirmBtn = document.getElementById("schdleBookConfrmBtn");
confirmBtn.addEventListener("click", () => {
  const selectedDate = document.querySelector(".day.active")?.dataset.date;
  const selectedTime = document.querySelector(".time-slot.selected")?.textContent;

  if (!selectedDate || !selectedTime) {
    alert("Please select both date and time before confirming your booking.");
    return;
  }

  // Convert date to desired format: "15th July, 2025"
  const dateObj = new Date(selectedDate);
  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("en-US", { month: "long" });
  const year = dateObj.getFullYear();

  const suffix = (d => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  })(day);

  const formattedDate = `${day}${suffix} ${month}, ${year}`;
  const bookingDateTimeFormatted = `${selectedTime.toLowerCase()}, ${formattedDate}`;

  // ✅ Output or use this variable as needed
  // console.log("Booking Date & Time:", bookingDateTimeFormatted);
  document.getElementById("bookConfrmSection").style.display = "block";
  document.getElementById("schdlBookingSection").style.display = "none";
  confirmBookingPage('Scheduled', bookingDateTimeFormatted);
});

let editSchdl = document.querySelector('#editSchdl');
editSchdl.addEventListener('click', function () {
  document.getElementById("schdlBookingSection").style.display = "block";
  document.getElementById("bookConfrmSection").style.display = "none";
  let currentDate = new Date();
  fetchAndRenderSlots(formatOnlyDate(currentDate)); // load time slots for today
});

let rdctrttlic = document.querySelectorAll('.rdctr-ttlic');
rdctrttlic.forEach((eleBk) => {
  eleBk.addEventListener('click', function () {
    document.getElementById("editSchdl").style.display = "none";
  });
});


// let finalBckBtn = document.querySelector('#finalBckBtn');
// finalBckBtn.addEventListener('click', function () {
//   document.getElementById("consltDptmntSection").style.display = "block";
//   document.getElementById("finalConfrmSection").style.display = "none";
// });

document.getElementById('finalBckBtn').addEventListener('click', function () {
  location.replace(location.href);
});

function finalBookingConfirmation(bookingMode, bookingDateTime, babyDetails) {
  confirmBookingBtn.classList.add('disbtn');
  
  let showStatusClass = document.querySelector(".show-status");
  if(showStatusClass) {
    showStatusClass.remove();
  }
  let appendNodeClass = '.rd-form';
  
  // console.log("bookingMode")
  // console.log(bookingMode)
  
  // console.log("Baby Name:", babyDetails.babyName);
  // console.log("Baby Age:", babyDetails.babyAge);
  // console.log("Parent Name:", babyDetails.parentName);
  // console.log("Concern:", babyDetails.concern);
  // console.log("Mobile:", babyDetails.mobile);
  // console.log("Email:", babyDetails.email);
  console.log("bookingDateTime");
  console.log(bookingDateTime);
  // let getdatetime = bookingDateTime.replace(/(\d+)(st|nd|rd|th)/, '$1'); // → "5:00 pm, 22 July, 2025"
  // // Parse it to a local Date object
  // let localDate = new Date(getdatetime);
  // // Convert to UTC ISO format
  // let utcISOString = localDate.toISOString().replace('.000', '');
  // console.log("UTC Time:", utcISOString);


  const localDate = parseBookingDateTime(bookingDateTime);

  if (!localDate || isNaN(localDate.getTime())) {
    console.error("Invalid bookingDateTime:", bookingDateTime);
    return;
  }

  // Convert to UTC ISO (backend-friendly)
  const utcISOString = localDate.toISOString().replace('.000', '');
  console.log("UTC Time:", utcISOString);

  let appointmentData = {
    customerName: babyDetails.parentName,
    patientName: babyDetails.babyName,
    patientDob: babyDetails.babyAge,
    phone: babyDetails.mobile,
    consultationTime: utcISOString,
    concern: babyDetails.concern,
    email: babyDetails.email,
    bookingMode: bookingMode,
    bookingDateTime: bookingDateTime,
  };

  fetch('https://phplaravel-1064273-5765427.cloudwaysapps.com/api/rforrabbit/create-appointment', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(appointmentData)
  })
  .then(res => res.json())
  .then(resdata => {
    // console.log(resdata);
    if(resdata.success) {
      if(resdata.data.status == 'error') {
        let errmsg = resdata.data?.errors?.booking_error || resdata.data?.message || "Something went wrong.";
        if(errmsg == 'Invalid request parameters.'){
          errmsg = 'Consultation time must be in the future.'
        }
        showStatus(errmsg, 'errmsg', appendNodeClass);
        confirmBookingBtn.classList.remove('disbtn');
        return;
      }
      if(resdata.data.status == 'success') {
        let succmsg = resdata.data?.message || "Something went wrong.";
        showStatus(succmsg, 'succmsg', appendNodeClass);
        confirmBookingBtn.classList.remove('disbtn');
        
        const [timeStr, dateStr] = bookingDateTime.split(', ');
        // Remove 'st', 'nd', 'rd', 'th' from day
        const normalizedDateStr = dateStr.replace(/(\d+)(st|nd|rd|th)/, '$1');
        // Combine to parse with Date object
        const fullDateStr = `${normalizedDateStr}, ${bookingDateTime.split(', ')[2]} ${timeStr.toUpperCase()}`;
        const dateObj = new Date(fullDateStr);
        // Format time
        const formattedTime = dateObj.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }).replace(' ', '').toUpperCase(); // e.g., "10:45AM"
        // Format date
        const weekday = dateObj.toLocaleDateString('en-In', { weekday: 'long' });
        const day = dateObj.getDate().toString().padStart(2, '0');
        const month = dateObj.toLocaleDateString('en-In', { month: 'long' });
        const fullYear = dateObj.getFullYear();
        const formattedDate = `${weekday}, ${day} ${month}, ${fullYear}`; // e.g., "Friday, 15 May 2025"
      
        // console.log("Formatted Time:", formattedTime);
        // console.log("Formatted Date:", formattedDate);
      
        let altConfrmTime = document.querySelector('#altConfrmTime');
        altConfrmTime.innerHTML = formattedTime;
        let altConfrmDate = document.querySelector('#altConfrmDate');
        altConfrmDate.innerHTML = formattedDate;
        let finParntName = document.querySelector('#finParntName');
        finParntName.textContent = `${babyDetails.parentName},`;

        fetch('https://phplaravel-1064273-5765427.cloudwaysapps.com/api/rforrabbit/store-appointments', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(appointmentData)
        })
        .then(res => res.json())
        .then(dbres => {
          // if(dbres.success) {
            setTimeout(() => {
              document.getElementById("bookConfrmSection").style.display = "none";
              document.getElementById("finalConfrmSection").style.display = "block";
            }, "2000");
          // }
        })
        .catch(err => {
          console.error("Error in appointment creation:", err);
          let errmsg = `<span>Something went wrong. Try after sometime.</span>`;
          showStatus(errmsg, 'errmsg', appendNodeClass);
          confirmBookingBtn.classList.remove('disbtn');
        }); 
      }
    }
  })
  .catch(err => {
    console.error("Error in appointment creation:", err);
    let errmsg = `<span>Something went wrong. Try after sometime.</span>`;
    showStatus(errmsg, 'errmsg', appendNodeClass);
    confirmBookingBtn.classList.remove('disbtn');
  });
}

function showStatus(msg, nodeClass, appendNodeClass) {
  let errDiv = document.createElement("div");
  errDiv.classList.add(nodeClass, 'show-status');
  errDiv.innerHTML = msg;
  let containerDiv = document.querySelector(appendNodeClass);
  containerDiv.appendChild(errDiv)
}


/* Run 15 min reusable task start */
// function run15MinTaskIST() {
//   let now = new Date();
//   let ist = getISTDate();
//   let hour = ist.getHours();
//   let minute = ist.getMinutes();
//   // Check if time is between 9:00 AM to 8:45 PM IST
//   let isWithinRange = (hour > 9 && hour < 20) || 
//                         (hour === 9 && minute >= 0) || 
//                         (hour === 20 && minute <= 45);

//   let isActive = document.getElementById("bookConfrmSection")?.classList.contains("custom-run");

//   if (isWithinRange && isActive) {
//     // console.log("✅ Task ran at:", formatISTTime(ist));

//     let consltMode = document.querySelector('#consltMode');
//     let bookingMode = consltMode.dataset.bookMode;
//     confirmBookingPage(bookingMode, '');
//   } else {
//     console.log("⏸️ Skipped at:", formatISTTime(ist));
//   }

//   // Schedule the next run
//   scheduleNext15Min(run15MinTaskIST);
// }

// function getISTDate() {
//   let now = new Date();
//   let utc = now.getTime() + (now.getTimezoneOffset() * 60000);
//   return new Date(utc + 5.5 * 60 * 60 * 1000);
// }

// function formatISTTime(date) {
//   return date.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true });
// }

// function scheduleNext15Min(callback) {
//   let ist = getISTDate();
//   let m = ist.getMinutes();
//   let s = ist.getSeconds();
//   let msToNextSlot = ((15 - (m % 15)) * 60 - s) * 1000;

//   setTimeout(callback, msToNextSlot);
// }

// scheduleNext15Min(run15MinTaskIST);
/* Run 15 min reusable task function end */







const weekContainer = document.getElementById("week-days");
const timeSlotContainer = document.getElementById("time-slots");
const selectedSlotInput = document.getElementById("selected-slot");
const monthLabel = document.getElementById("month-label");

const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

let loadedDates = []; // track loaded dates
let startDate = new Date(); // today

// Helper: Create one day element
function createDayElement(date, isActive = false) {
  const formattedDate = formatOnlyDate(date);

  const dayEl = document.createElement("div");
  dayEl.className = "day" + (isActive ? " active" : "");
  dayEl.dataset.date = formattedDate;
  dayEl.innerHTML = `
    <span class="day-name">${weekdays[date.getDay()]}</span>
    <span class="day-date">${date.getDate()}</span>`;

  dayEl.addEventListener("click", () => {
    document.querySelectorAll(".day").forEach(el => el.classList.remove("active"));
    dayEl.classList.add("active");
    fetchAndRenderSlots(formattedDate);
  });

  weekContainer.appendChild(dayEl);
  loadedDates.push(formattedDate);
}

// Initial 7 days
function loadInitialDates() {
  for (let i = 0; i < 7; i++) {
    const newDate = new Date();
    newDate.setDate(startDate.getDate() + i);
    createDayElement(newDate, i === 0);
  }
  let getMonth = months[startDate.getMonth()];
  let now = new Date();
  let getYear = now.getFullYear(); // Example: 2025
  monthLabel.textContent = `${getMonth} ${getYear}`;
}

// Infinite scroll: load next day on scroll
// const today = new Date();
// const maxScrollableDate = new Date(today.getFullYear(), today.getMonth() + 2, 0); // Create date object for the last day of next month, day 0 = last day of prev month
// weekContainer.addEventListener("scroll", () => {
//   const scrollLeft = weekContainer.scrollLeft;
//   const scrollRight = weekContainer.scrollWidth - weekContainer.clientWidth - scrollLeft;

//   // Load next day only if we haven't reached maxScrollableDate
//   if (scrollRight < 20) {
//     const lastDateStr = loadedDates[loadedDates.length - 1];
//     const lastDate = new Date(lastDateStr);
//     // Check if next day is still within allowed range
//     const nextDate = new Date(lastDate);
//     nextDate.setDate(nextDate.getDate() + 1);

//     if (nextDate <= maxScrollableDate) {
//       createDayElement(nextDate);
//     }
//   }

//   // Update visible month label
//   const dayElements = weekContainer.querySelectorAll('.day');
//   for (let i = 0; i < dayElements.length; i++) {
//     const rect = dayElements[i].getBoundingClientRect();
//     const containerRect = weekContainer.getBoundingClientRect();

//     if (rect.left >= containerRect.left && rect.right <= containerRect.right) {
//       const visibleDate = new Date(dayElements[i].dataset.date);
//       const visibleMonth = visibleDate.getMonth();

//       if (monthLabel.textContent !== months[visibleMonth]) {
//         monthLabel.textContent = months[visibleMonth];
//       }

//       break;
//     }
//   }
// });


// Fetch from API and render time slots
function fetchAndRenderSlots(date) {
  // console.log('fetchAndRenderSlots fun rnnnn')
  // console.log('date:', date);
  timeSlotContainer.innerHTML = `<div>Loading slots...</div>`;
  const requestData = {
    date: date
  };
  // console.log(JSON.stringify(requestData));

  fetch('https://phplaravel-1064273-5765427.cloudwaysapps.com/api/rforrabbit/slots', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
  })
  .then(res => res.json())
  .then(resdata => {
    // console.log(resdata)
    timeSlotContainer.innerHTML = "";
    let data = resdata.data;
    // console.log('slots data');
    // console.log(data);
    if (!Array.isArray(data) || data.length === 0) {
      timeSlotContainer.innerHTML = `<div>No slots available</div>`;
      return;
    }

    // data.forEach(slot => {
    //   const btn = document.createElement("button");
    //   btn.className = "time-slot";
    //   btn.textContent = formatTime(slot.start_time); // "09:00" → "9:00 AM"

    //   btn.addEventListener("click", () => {
    //     document.querySelectorAll(".time-slot").forEach(el => el.classList.remove("selected"));
    //     btn.classList.add("selected");
    //     selectedSlotInput.value = `${date} ${slot.start_time}`;
    //   });

    //   timeSlotContainer.appendChild(btn);
    // });

    data.forEach((slot, index) => {
      const btn = document.createElement("button");
      btn.className = "time-slot";
      btn.textContent = formatTime(slot.start_time);

      if (index === 0) {
        // --- check if this is the first slot and <7 minutes left ---
        const now = new Date(); // local current time
        const slotTime = getSlotDateObj(slot.date, slot.start_time);

        // console.log('slotTime: ', slotTime)

        const diffMs = slotTime - now;
        // console.log('diffMs: ', diffMs)
        const diffMins = diffMs / 60000;
        // console.log('diffMins: ', diffMins)

        if(diffMins <= 7) {
          // console.log('if diffMins <= 7')
          // disable or hide
          // btn.disabled = true; // option 1: disable button
          btn.style.display = "none"; // option 2: completely hide
        }
      }

      btn.addEventListener("click", () => {
        // if (btn.disabled) return; // prevent selection if disabled
        document.querySelectorAll(".time-slot").forEach(el => el.classList.remove("selected"));
        btn.classList.add("selected");
        selectedSlotInput.value = `${slot.date} ${slot.start_time}`;
      });

      timeSlotContainer.appendChild(btn);
    });
  })
  .catch(err => {
    console.error("Slot fetch error:", err);
    timeSlotContainer.innerHTML = `<div>Error loading slots</div>`;
  });
}

// Convert "HH:mm" string to Date object in Asia/Kolkata timezone
function getSlotDateObj(dateStr, timeStr) {
  const [h, m] = timeStr.split(":").map(Number);
  const dateObj = new Date(dateStr + "T" + timeStr + ":00+05:30"); // IST offset
  dateObj.setHours(h, m, 0, 0);
  return dateObj;
}

function formatTime(timeStr) {
  const [hour, minute] = timeStr.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

loadInitialDates();
/*** Chitrang Safari error */

function parseBookingDateTime(str) {
  // Remove ordinal suffixes: 22nd → 22
  const cleaned = str
    .replace(/(\d+)(st|nd|rd|th)/i, "$1")
    .trim();

  // Match: HH:MM am/pm, DD Month, YYYY
  const regex = /^(\d{1,2}):(\d{2})\s*(am|pm),\s*(\d{1,2})\s*([A-Za-z]+),\s*(\d{4})$/i;
  const match = cleaned.match(regex);

  if (!match) return null;

  let [, hour, minute, meridiem, day, monthName, year] = match;

  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);
  day = parseInt(day, 10);
  year = parseInt(year, 10);

  // Month map (Safari-safe)
  const months = {
    january: 0, february: 1, march: 2, april: 3,
    may: 4, june: 5, july: 6, august: 7,
    september: 8, october: 9, november: 10, december: 11
  };

  const monthIndex = months[monthName.toLowerCase()];
  if (monthIndex === undefined) return null;

  // Convert 12-hour → 24-hour
  meridiem = meridiem.toLowerCase();
  if (meridiem === "pm" && hour < 12) hour += 12;
  if (meridiem === "am" && hour === 12) hour = 0;

  // Create LOCAL date safely
  return new Date(year, monthIndex, day, hour, minute, 0);
}
